document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll(".mega-menu__menu-wrapper");
  const details = document.querySelectorAll(".mega-menu__details-subwrapper");

  menuItems.forEach((item) => {
    item.addEventListener("click", function () {
      const menuId = item.id;

      // Remove 'mega-menu__menu-wrapper--selected' from all menu items
      menuItems.forEach((menuItem) => {
        menuItem.classList.remove("mega-menu__menu-wrapper--selected");
      });

      // Add the class to the clicked menu item
      item.classList.add("mega-menu__menu-wrapper--selected");

      // Hide all detail sections by adding the 'hidden' class
      details.forEach((detail) => {
        detail.classList.add("hidden");
      });

      // Show the corresponding detail section based on the clicked menu item
      const detailId = menuId + "-detail";
      const detailToShow = document.getElementById(detailId);
      if (detailToShow) {
        detailToShow.classList.remove("hidden");
      }
    });
  });
});
